<div class="comment-content pt-0 h-100">
  @if ((this.commentBase$ | async); as comments) {
    <!--      <div class="row new-comment-container" [class]="{'bg-light':newComment.isVisible}">-->
    <!--        <div class="col">-->
    <!--          <button class="btn btn-sm btn-outline-primary mt-1" (click)="newComment.isVisible = !newComment.isVisible"-->
    <!--                  translate>COMMENT_LBL_NEW_COMMENT-->
  <!--          </button>-->
<!--        </div>-->
<!--      </div>-->
<app-comment-add #newComment [entityId]="this.entityId" [entityType]="this.entityType"
(newComment)="refresh($event)"></app-comment-add>
@if (comments.length >= 1) {
  <ul class="list-group list-group-flush">
    @for (comment of comments; track trackByComment($index, comment)) {
      <li class="list-group-item align-items-start mt-2 px-1 py-2"
        >
        <app-comment [comment]="comment" class="d-flex"></app-comment>
      </li>
    }
  </ul>
}
<!--    <ng-container *ngIf="comments.length == 0 && !newComment.isVisible">-->
@if (comments.length == 0) {
  <app-comment-none></app-comment-none>
}
}
</div>
